module.exports = __webpack_public_path__ + "static/media/teamLeaderUserGuide.132db4f7.pdf";